import React from "react";

export const IconClose = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <path d="M17.393 2.487a1.33 1.33 0 1 0-1.88-1.88L9 7.12 2.487.607a1.33 1.33 0 0 0-1.88 1.88L7.12 9 .607 15.513a1.33 1.33 0 1 0 1.88 1.88L9 10.88l6.513 6.513a1.33 1.33 0 0 0 1.88-1.88L10.88 9l6.513-6.513Z" />
    </svg>
  );
};
